// Shared geometry for the full-bounds weather heatmap quads (wind / precipitation /
// lightning). All three sample an equirectangular (linear-in-latitude) data texture and
// draw it over a Web Mercator basemap.
//
// A naive 4-vertex quad only projects its corners correctly: the GPU then linearly
// interpolates clip-space position AND texture coordinate across the interior, but
// Mercator screen-Y is a *non-linear* function of latitude. The result is a vertical
// drift of the texture relative to the basemap that is invisible when zoomed in (small
// latitude window ≈ linear) and grows as you zoom out.
//
// Tessellating the quad into many latitude bands fixes this: each band's vertices carry
// their true latitude (so each is Mercator-projected correctly by the vertex shader) and
// their linear-in-latitude texture coordinate, and within a thin band the linear
// interpolation error is sub-pixel. This mirrors how deck.gl's own BitmapLayer handles
// non-linear projections. Longitude is linear in Mercator, so only the latitude axis
// needs subdivision — a 2-wide strip suffices.

export const HEATMAP_LAT_BANDS = 128

export const buildLatBandedStrip = (bands: number): Float32Array => {
    const rows = bands + 1
    const positions = new Float32Array(rows * 2 * 2)
    for (let i = 0; i < rows; i++) {
        const y = (i / bands) * 2 - 1
        const offset = i * 4
        positions[offset] = -1
        positions[offset + 1] = y
        positions[offset + 2] = 1
        positions[offset + 3] = y
    }
    return positions
}

export const HEATMAP_QUAD_POSITIONS = buildLatBandedStrip(HEATMAP_LAT_BANDS)
export const HEATMAP_QUAD_VERTEX_COUNT = 2 * (HEATMAP_LAT_BANDS + 1)
